import { karateR0Login, karateR0Me, karateR0Logout } from "./karateR0ApiClient.js";

const DEFAULT_HANSHI_EMAIL = "local-hanshi@example.test";
const DEFAULT_HANSHI_PASSWORD = "local-dev-only-change-me";
const DEFAULT_SENSEI_EMAIL = "local-sensei@example.test";
const DEFAULT_SENSEI_PASSWORD = "local-dev-only-change-me";

/** @type {Promise<{ ok: boolean, status?: number }> | null} */
let syncInFlight = null;

function hanshiR0Credentials() {
  return {
    email: import.meta.env.VITE_KARATE_R0_HANSHI_EMAIL || DEFAULT_HANSHI_EMAIL,
    password: import.meta.env.VITE_KARATE_R0_HANSHI_PASSWORD || DEFAULT_HANSHI_PASSWORD,
  };
}

function senseiR0Credentials() {
  return {
    email: import.meta.env.VITE_KARATE_R0_SENSEI_EMAIL || DEFAULT_SENSEI_EMAIL,
    password: import.meta.env.VITE_KARATE_R0_SENSEI_PASSWORD || DEFAULT_SENSEI_PASSWORD,
  };
}

function isHanshiAuth(auth) {
  return auth?.role === "hanshi" || auth?.role === "admin";
}

function isSenseiAuth(auth) {
  return auth?.role === "sensei";
}

async function doEnsureKarateR0Session({ auth, password } = {}) {
  const me = await karateR0Me();
  if (me.response.ok) return { ok: true };

  if (!isHanshiAuth(auth) && !isSenseiAuth(auth)) return { ok: false, status: me.response.status };

  if (auth.authSource === "backend" && password) {
    const email = String(auth.username || "").includes("@")
      ? auth.username
      : `${auth.username}@example.test`;
    const attempt = await karateR0Login(email.trim().toLowerCase(), password);
    if (attempt.response.ok) return { ok: true };
  }

  const mapped = isSenseiAuth(auth) ? senseiR0Credentials() : hanshiR0Credentials();
  const login = await karateR0Login(mapped.email, mapped.password);
  return { ok: login.response.ok, status: login.response.status };
}

/**
 * Établit silencieusement la session cookie R0 pour un Hanshi déjà connecté dans phase1.
 * @param {{ auth?: object, password?: string }} [options]
 */
export async function ensureKarateR0Session(options = {}) {
  if (!syncInFlight) {
    syncInFlight = doEnsureKarateR0Session(options).finally(() => {
      syncInFlight = null;
    });
  }
  return syncInFlight;
}

export async function clearKarateR0Session() {
  await karateR0Logout();
}
